"use client"

import { ComponentConfig } from "@measured/puck"
import { RenderConfig, StoreLocatorProps } from "./RenderConfig"

export const StoreLocator: ComponentConfig<StoreLocatorProps> = {
    label: "Tamda Foods | Store Locator",
    fields: {
        title: {
            label: "Title",
            type: "text",
        },
        className: {
            label: "Class Name",
            type: "text",
        },
    },
    defaultProps: {
        title: "CỬA HÀNG CỦA CHÚNG TÔI",
        className: "",
    },
    ...RenderConfig,
}
